define(function (require) {

    "use strict";

    var _ = require("underscore");
    var Marionette = require("marionette");
    var template = require("ui/image-carousel/templates/imageCarouselItemView.tmpl");

    var ImageCarouselItemView = Marionette.ItemView.extend({

        template: template,
        tagName : "li",

        triggers: {
            "click": "click"
        },

        events:{
            "click .carousel-item": "onItemClick"
        },

        initialize: function (options) {
            this.itemIndex = options.itemIndex;
        },

        show:function(){
            this.$el.show();
        },

        hide:function(){
            this.$el.hide();
        }
    });

    return ImageCarouselItemView;
});
